import React, { useState, useEffect } from "react";

/** The thin accent bar across the top of the viewport showing how far the page is read. */
const ScrollProgress = () => {
	const [progress, setProgress] = useState(0);

	useEffect(() => {
		const handleScroll = () => {
			const el = document.documentElement;
			const scrolled = el.scrollTop || document.body.scrollTop;
			const total = el.scrollHeight - el.clientHeight;
			setProgress(total > 0 ? scrolled / total : 0);
		};

		window.addEventListener("scroll", handleScroll, { passive: true });
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	// scaleX on a full-width bar stays on the compositor; animating width
	// forces layout on every scroll frame.
	return (
		<div
			aria-hidden="true"
			style={{
				position: "fixed",
				top: 0,
				left: 0,
				width: "100%",
				height: "2px",
				background: "var(--pp-accent)",
				zIndex: 9999,
				transform: `scaleX(${progress})`,
				transformOrigin: "left",
				transition: "transform 0.05s linear",
				pointerEvents: "none",
			}}
		/>
	);
};

export default ScrollProgress;
